import { render, staticRenderFns } from "./teams-results.vue?vue&type=template&id=568efeca&scoped=true&"
import script from "./teams-results.vue?vue&type=script&lang=ts&"
export * from "./teams-results.vue?vue&type=script&lang=ts&"
import style0 from "./teams-results.vue?vue&type=style&index=0&id=568efeca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568efeca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
